import type {
  ConditionSelection,
  ConditionSelectionType,
  ConditionValue,
} from '../conditions.types';
import {
  isMultiselectRangeValue,
  isRangeValue,
} from './conditionSelection.util';

const isEmptyValue = (value: ConditionValue): boolean => {
  if (isMultiselectRangeValue(value)) {
    return Object.keys(value).length === 0;
  }

  return isRangeValue(value)
    ? value.max === undefined && value.min === undefined
    : value.length === 0;
};

const omitCondition = (
  values: Record<string, ConditionValue>,
  key: string
): Record<string, ConditionValue> => {
  const updatedSelection = { ...values };

  delete updatedSelection[key];

  return updatedSelection;
};

/**
 * A section is either included or excluded, so switching a section's selection
 * type replaces rather than accumulates.
 */
export const updateConditionSelection = (
  selection: ConditionSelection,
  selectionType: ConditionSelectionType,
  key: string,
  value?: ConditionValue
): ConditionSelection => {
  const updatedSelection: ConditionSelection = {
    excludes: omitCondition(selection.excludes, key),
    includes: omitCondition(selection.includes, key),
  };

  if (value !== undefined && !isEmptyValue(value)) {
    updatedSelection[selectionType][key] = value;
  }

  return updatedSelection;
};

export const deselectCondition = (
  selection: ConditionSelection,
  key: string
): ConditionSelection => ({
  excludes: omitCondition(selection.excludes, key),
  includes: omitCondition(selection.includes, key),
});
